module.exports = "<fuse-navigation layout=\"horizontal\"></fuse-navigation>\n"